import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=70d8f17e&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=70d8f17e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8f17e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d8f17e')) {
      api.createRecord('70d8f17e', component.options)
    } else {
      api.reload('70d8f17e', component.options)
    }
    module.hot.accept("./OrderHistory.vue?vue&type=template&id=70d8f17e&scoped=true", function () {
      api.rerender('70d8f17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BarActions/OrderHistory.vue"
export default component.exports